import axios from "@/api/axios";

const departmentList = (data) => {
    return axios
        .post('/admin/department/list', {department: data})
        .then(response => response.data)
}

const departmentCreate = (data) => {
    return axios
        .post('/admin/department/create', {department: data})
        .then(response => response.data)
}

const departmentUpdate = (data) => {
    return axios
        .post('/admin/department/update', {department: data})
        .then(response => response.data)
}

const stockList = (data) => {
    return axios
        .post('/admin/department/stock-list', {stock: data})
        .then(response => response.data)
}

const getStockInfo = (data) => {
    return axios
        .post('/admin/department/stock-info', {stock: data})
        .then(response => response.data)
}

const getReceiptsAllList = (data) => {
    return axios
        .post('/admin/department/receipts-list', {stock: data})
        .then(response => response.data)
}

const updateReceipt = (data) => {
    return axios
        .post('/admin/department/update-receipt', {stock: data})
        .then(response => response.data)
}

const createReceipt = (data) => {
    return axios
        .post('/admin/department/create-receipt', {stock: data})
        .then(response => response.data)
}

const getStockSuppliers = (data) => {
    return axios
        .post('/admin/department/stock-suppliers', {stock: data})
        .then(response => response.data)
}

export default {
    departmentList,
    departmentCreate,
    departmentUpdate,
    stockList,
    getStockInfo,
    getReceiptsAllList,
    updateReceipt,
    createReceipt,
    getStockSuppliers
}